import { render, staticRenderFns } from "./LoadingMessages.vue?vue&type=template&id=16fcf45f&"
import script from "./LoadingMessages.vue?vue&type=script&lang=js&"
export * from "./LoadingMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports